import PropTypes from "prop-types";
import React, { Fragment, useState, useEffect, useRef } from "react";
import Swiper from "react-id-swiper";
import { getProductCartQuantity } from "../../helpers/product";
import { Modal } from "antd";
import Rating from "./sub-components/ProductRating";
import { connect } from "react-redux";
import confirm from "antd/lib/modal/confirm";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { getPriceRelatedToCustomer, tobaccoEligibilityMessage } from "../../pages/constant/utils";
import { useHistory } from "react-router-dom";

function ProductModal(props, userDetail,userData) {
  const { product } = props;
  const { currency } = props;
  const { discountedprice } = props;
  const { finalproductprice } = props;
  const { finaldiscountedprice } = props;
  const { settingData } = props;

  const {
    price_display_for_secure_user,
    price_display_for_unsecure_user,
    stock_display_for_unsecure_user,
    stock_display_for_secure_user,
  } = settingData || {};

  const customerBasedfinalProductPrice = +(
    Number(getPriceRelatedToCustomer(props.userData, product)) *
    currency.currencyRate
  ).toFixed(2);
  const history = useHistory();
  let modalRef = useRef(null);
  const licensePath = () => history.push('/profile/my-account')
  const [gallerySwiper, getGallerySwiper] = useState(null);
  const [thumbnailSwiper, getThumbnailSwiper] = useState(null);
  const [selectedProductColor, setSelectedProductColor] = useState(
    product.variation ? product.variation[0].color : ""
  );
  const [selectedProductSize, setSelectedProductSize] = useState(
    product.variation ? product.variation[0].size[0].name : ""
  );
  const [productStock, setProductStock] = useState(
    product.variation ? product.variation[0].size[0].stock : product.stock
  );
  const [quantityCount, setQuantityCount] = useState(1);

  const wishlistItem = props.wishlistitem;
  const compareItem = props.compareitem;

  const addToCart = props.addtocart;
  const addToWishlist = props.addtowishlist;
  const addToCompare = props.addtocompare;

  const addToast = props.addtoast;
  const cartItems = props.cartitems;

  const productCartQty = getProductCartQuantity(
    cartItems,
    product,
    selectedProductColor,
    selectedProductSize
  );

  useEffect(() => {
    if (
      gallerySwiper !== null &&
      gallerySwiper.controller &&
      thumbnailSwiper !== null &&
      thumbnailSwiper.controller
    ) {
      gallerySwiper.controller.control = thumbnailSwiper;
      thumbnailSwiper.controller.control = gallerySwiper;
    }
  }, [gallerySwiper, thumbnailSwiper]);

  const gallerySwiperParams = {
    getSwiper: getGallerySwiper,
    spaceBetween: 10,
    loopedSlides: 4,
    loop: true,
  };

  const thumbnailSwiperParams = {
    getSwiper: getThumbnailSwiper,
    spaceBetween: 10,
    slidesPerView: 4,
    loopedSlides: 4,
    touchRatio: 0.2,
    freeMode: true,
    loop: true,
    slideToClickedSlide: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    renderPrevButton: () => (
      <button className="swiper-button-prev ht-swiper-button-nav">
        <i className="pe-7s-angle-left" />
      </button>
    ),
    renderNextButton: () => (
      <button className="swiper-button-next ht-swiper-button-nav">
        <i className="pe-7s-angle-right" />
      </button>
    ),
  };

  return (
    <Fragment>
      <Modal
        show={props.show}
        onHide={props.onHide}
        className="product-quickview-modal-wrapper"
      >
        <Modal.Header closeButton></Modal.Header>

        <div className="modal-body">
          <div className="row">
            <div className="col-md-5 col-sm-12 col-xs-12">
              <div className="product-large-image-wrapper">
                <Swiper {...gallerySwiperParams}>
                  {product.images &&
                    product.images.map((single, key) => {
                      return (
                        <div key={key}>
                          <div className="single-image">
                            <img
                              src={process.env.PUBLIC_URL + single}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                        </div>
                      );
                    })}
                </Swiper>
              </div>
              <div className="product-small-image-wrapper mt-15">
                <Swiper {...thumbnailSwiperParams}>
                  {product.images &&
                    product.images.map((single, key) => {
                      return (
                        <div key={key}>
                          <div className="single-image">
                            <img
                              src={process.env.PUBLIC_URL + single}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                        </div>
                      );
                    })}
                </Swiper>
              </div>
            </div>
            <div className="col-md-7 col-sm-12 col-xs-12">
              <div className="product-details-content quickview-content">
                <h2>{product?.ecom_name || product?.name}</h2>
                {/* Price will only shows to those customer who will log in */}
                {(props.userData
                  ? price_display_for_secure_user
                  : price_display_for_unsecure_user) && (
                  <div className="product-details-price">
                    <span>
                      {currency.currency_symbol +
                        customerBasedfinalProductPrice}{" "}
                    </span>
                  </div>
                )}
                {product.rating && product.rating > 0 ? (
                  <div className="pro-details-rating-wrap">
                    <div className="pro-details-rating">
                      <Rating ratingValue={product.rating} />
                    </div>
                  </div>
                ) : (
                  ""
                )}
                <div className="pro-details-list">
                  <div
                    className="float-left fluid-left"
                    dangerouslySetInnerHTML={{
                      __html: product ? product.description : "",
                    }}
                  />
                </div>

                {product.variation ? (
                  <div className="pro-details-size-color">
                    <div className="pro-details-color-wrap">
                      <span>Color</span>
                      <div className="pro-details-color-content">
                        {product.variation.map((single, key) => {
                          return (
                            <label
                              className={`pro-details-color-content--single ${single.color}`}
                              key={key}
                            >
                              <input
                                type="radio"
                                value={single.color}
                                name="product-color"
                                checked={
                                  single.color === selectedProductColor
                                    ? "checked"
                                    : ""
                                }
                                onChange={() => {
                                  setSelectedProductColor(single.color);
                                  setSelectedProductSize(single.size[0].name);
                                  setProductStock(single.size[0].stock);
                                  setQuantityCount(1);
                                }}
                              />
                              <span className="checkmark"></span>
                            </label>
                          );
                        })}
                      </div>
                    </div>
                    <div className="pro-details-size">
                      <span>Size</span>
                      <div className="pro-details-size-content">
                        {product.variation &&
                          product.variation.map((single) => {
                            return single.color === selectedProductColor
                              ? single.size.map((singleSize, key) => {
                                  return (
                                    <label
                                      className={`pro-details-size-content--single`}
                                      key={key}
                                    >
                                      <input
                                        type="radio"
                                        value={singleSize.name}
                                        checked={
                                          singleSize.name ===
                                          selectedProductSize
                                            ? "checked"
                                            : ""
                                        }
                                        onChange={() => {
                                          setSelectedProductSize(
                                            singleSize.name
                                          );
                                          setProductStock(singleSize.stock);
                                          setQuantityCount(1);
                                        }}
                                      />
                                      <span className="size-name">
                                        {singleSize.name}
                                      </span>
                                    </label>
                                  );
                                })
                              : "";
                          })}
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {product.affiliateLink ? (
                  <div className="pro-details-quality">
                    <div className="pro-details-cart btn-hover">
                      <a
                        href={product.affiliateLink}
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        Buy Now
                      </a>
                    </div>
                  </div>
                ) : (
                  <>
                    {(props.userData
                      ? stock_display_for_secure_user
                      : stock_display_for_unsecure_user) && (
                      <p>
                        Only <b>{product.saleable_qty}</b> products are in stock
                      </p>
                    )}

                    <div className="pro-details-quality">
                      <div className="cart-plus-minus">
                        <button
                          onClick={() =>
                            setQuantityCount(
                              Number(quantityCount) > 1
                                ? Number(quantityCount) - 1
                                : 1
                            )
                          }
                          className="dec qtybutton"
                        >
                          -
                        </button>
                        <input
                          className="cart-plus-minus-box"
                          style={{ marginTop: "12px" }}
                          type="text"
                          value={quantityCount}
                          onChange={({ target: { value } }) => {
                            if (Number(value) <= product.saleable_qty) {
                              setQuantityCount(value);
                            }
                          }}
                        />
                        <button
                          onClick={() => {
                            setQuantityCount(
                              Number(quantityCount) < product.saleable_qty
                                ? Number(quantityCount) + 1
                                : Number(quantityCount)
                            );
                          }}
                          className="inc qtybutton"
                        >
                          +
                        </button>
                      </div>
                      <div className="pro-details-cart btn-hover">
                        {(product.saleable_qty && product.saleable_qty > 0) ||
                        product?.back_order_ecom ? (
                          <button
                            onClick={() => {
                              if (!userDetail?.user) {
                                addToast(
                                  "Please login first to view the cart",
                                  {
                                    appearance: "info",
                                    autoDismissTimeout: 1000,
                                    autoDismiss: true,
                                  }
                                );
                              } else {
                                if (
                                  !product.is_tobacco ||
                                  settingData.skip_eligibility_check || props.userData.tobacco_eligibility
                                ) {
                                 
                                  addToCart(
                                    product,
                                    addToast,
                                    cartItems,
                                    Number(quantityCount),
                                    settingData.channel_id,
                                  );
                                } else {

                                  modalRef.current = confirm({
                                    // title:
                                    //   "Do you Want to keep tobacco products in cart?",
                                    icon: <ExclamationCircleOutlined />,
                                    placement: "bottomRight",
                                    content: tobaccoEligibilityMessage(licensePath,modalRef),
                                    onOk() {},
                                    onCancel() {},
                                    cancelText: "Close",
                                  });

                                }
                              }
                            }}
                            disabled={
                              ["", 0, null].includes(quantityCount) ||
                              productCartQty + Number(quantityCount) >
                                product.saleable_qty
                            }
                          >
                            {" "}
                            Add To Cart{" "}
                          </button>
                        ) : (
                          <button disabled>Out of Stock</button>
                        )}
                      </div>
                      <div className="pro-details-wishlist">
                        <button
                          className={wishlistItem !== undefined ? "active" : ""}
                          disabled={wishlistItem !== undefined}
                          title={
                            wishlistItem !== undefined
                              ? "Added to wishlist"
                              : "Add to wishlist"
                          }
                          onClick={() => addToWishlist(product, addToast)}
                        >
                          <i className="pe-7s-like" />
                        </button>
                      </div>
                      <div className="pro-details-compare">
                        <button
                          className={compareItem !== undefined ? "active" : ""}
                          disabled={compareItem !== undefined}
                          title={
                            compareItem !== undefined
                              ? "Added to compare"
                              : "Add to compare"
                          }
                          onClick={() => addToCompare(product, addToast)}
                        >
                          <i className="pe-7s-shuffle" />
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </Fragment>
  );
}

ProductModal.propTypes = {
  addtoast: PropTypes.func,
  addtocart: PropTypes.func,
  addtocompare: PropTypes.func,
  addtowishlist: PropTypes.func,
  cartitems: PropTypes.array,
  compareitem: PropTypes.object,
  currency: PropTypes.object,
  discountedprice: PropTypes.number,
  finaldiscountedprice: PropTypes.number,
  finalproductprice: PropTypes.number,
  onHide: PropTypes.func,
  product: PropTypes.object,
  userData: PropTypes.object,
  show: PropTypes.bool,
  wishlistitem: PropTypes.object,
  settingData: PropTypes.object,
  userDetail: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    cartitems: state.cartData,
    settingData: state.settingData.ecom.basic,
    userData: state.userData.user,
    userDetail: state.userData,
    currency:state.settingData?.["admin-panel"]?.basic||{},
  };
};

export default connect(mapStateToProps)(ProductModal);
